import type { SegmentCollectionItem } from '~/types/article';

export function useCardProps () {
  const getCommonCardProps = (item: SegmentCollectionItem, imageHide = false) => ({
    id: item.id,
    prefetch: false,
    title: item.editionContent?.title || item.title,
    lead_asset: item.editionContent?.leadAsset || item.leadAsset,
    meta: item.editionContent?.meta || item.topic?.label || '',
    features: {
      badge: item.editionContent?.features?.badge,
      source: item.editionContent?.features?.source
    },
    mobile_image_position: item.editionContent?.mobileImagePosition || item.mobileImagePosition,
    kicker: item.editionContent?.kicker || '',
    image_position: item.editionContent?.imagePosition || item.imagePosition,

    // Not From edition Content
    type: item.type,
    priority: item.priority,
    strapline: item.strapline,
    lead: item.lead,
    image_hide: imageHide,
    canonical_slug: item.canonicalSlug,
    theme: item.editionContent?.theme || item.metadata?.theme,
    url: item.canonicalSlug,
    publication: item.publication,
    teaser_type: item.type,
    article_type: item.type
  });

  return { getCommonCardProps };
}
